export default __webpack_public_path__ + "static/media/07_sipky_d-min.dd4d88dc.jpg";